import SellersTable from './SellersTable.component';

export default SellersTable;
